export const colorDeepOrLightDetector = (hexColor) => {
  /**
   * Determines if the given hex color code represents a deep or light color.
   *
   * @param {string} hexColor - The hex color code (e.g., "#5300eb")
   * @returns {boolean} - True if the color is deep, False if the color is light.
   */

  hexColor = hexColor.replace('#', '');

  // Convert hex to RGB
  let r = parseInt(hexColor.substring(0, 2), 16);
  let g = parseInt(hexColor.substring(2, 4), 16);
  let b = parseInt(hexColor.substring(4, 6), 16);

  // Calculate luminance using the formula
  let luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // Define a threshold for deep vs. light
  // This threshold can be adjusted based on your definition of deep and light
  let threshold = 128;

  // Return true if the color is deep, false otherwise
  return luminance < threshold;
};